import type { SVGProps } from 'react';
const SvgDeleteSweep = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#delete_sweep_svg__a)">
      <path
        fill="currentColor"
        d="M15 16h4v2h-4v-2Zm0-8h7v2h-7V8Zm0 4h6v2h-6v-2ZM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10ZM14 5h-3l-1-1H6L5 5H2v2h12V5Z"
      />
    </g>
    <defs>
      <clipPath id="delete_sweep_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDeleteSweep;
